import Coordinator from './coordinator';

export default class SmartSelectElement {
  #domElement;
  #coordinator;

  constructor (domElement, bbox) {
    this.#domElement = domElement;
    this.#coordinator = new Coordinator(bbox);
  }

  getCoordinator () {
    return this.#coordinator;
  }

  getDomElement () {
    return this.#domElement;
  }

  getId () {
    return this.#domElement.id;
  }
}
